<template lang="pug">
  div(
    class="billing-payment-info pa-4"
    :class="{ gray: gray }"
  )
    div(
      v-if="loading"
      class="billing-payment-info__loader"
    )
      v-skeleton-loader(
        type="article, paragraph@2"
        height="126"
      )
    template(v-else)
      div(
        v-if="firstRow"
        class="d-flex justify-space-between align-center pb-2"
      )
        div(class="text-12px fw-300") {{ firstRow.label }}
        div(class="text-12px fw-300") {{ firstRow.value }}
      div(
        v-if="secondRow"
        class="d-flex justify-space-between align-center pb-2"
      )
        div(class="d-flex align-center")
          div(class="text-12px fw-300") {{ secondRow.label }}
          v-tooltip(
            v-if="secondRow.tooltip"
            bottom
          )
            template(v-slot:activator="{ on }")
              e-svg-icon(
                v-on="on"
                size="xsm"
                class="ml-1"
              ) info-circle
            span {{ secondRow.tooltip.text }}
        div(class="text-12px fw-300") {{ secondRow.value }}
      div(
        v-if="thirdRow"
        class="d-flex justify-space-between align-center pb-2"
      )
        div(class="d-flex align-center")
          div(class="text-12px fw-300") {{ thirdRow.label }}
          v-tooltip(
            v-if="thirdRow.tooltip"
            bottom
          )
            template(v-slot:activator="{ on }")
              e-svg-icon(
                v-on="on"
                size="xsm"
                class="ml-1"
              ) info-circle
            span {{ thirdRow.tooltip.text }}
        div(class="text-12px fw-300") {{ thirdRow.value }}
      v-divider(class="my-3")
      div(class="d-flex justify-space-between align-center")
        div(class="d-flex align-center")
          div(class="text-14px dark fw-500") {{ summaryRow.label }}
          v-tooltip(
            v-if="summaryRow.tooltip"
            bottom
          )
            template(v-slot:activator="{ on }")
              e-svg-icon(
                v-on="on"
                size="xsm"
                class="ml-1"
              ) info-circle
            span {{ summaryRow.tooltip.text }}
        div(class="text-14px dark fw-500") {{ summaryRow.value }}
</template>

<script>
export default {
  name: 'BillingPaymentInfo',
  props: {
    info: {
      type: Object,
      default: () => ({})
    },
    gray: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    firstRow() {
      return this._.get(this.info, 'firstRow')
    },
    secondRow() {
      return this._.get(this.info, 'secondRow')
    },
    thirdRow() {
      return this._.get(this.info, 'thirdRow')
    },
    summaryRow() {
      return this._.get(this.info, 'summaryRow')
    }
  }
}
</script>

<style scoped lang="scss">
.billing-payment-info {
  border-radius: 12px;
  background: $white;
  padding: 12px;

  &.gray {
    background: #f8f8f8;
  }
}
</style>
